// extracted by mini-css-extract-plugin
export default {"verifyIcon":"Header_verifyIcon__7wy9f","pic":"Header_pic__AfoOq","userName":"Header_userName__HoT1N","userDesc":"Header_userDesc__5U8-p"};